import { a as HiddenContainer } from './chunk-ac382c96.js';
import { theme } from 'styled-tools';
import styled from './styled.js';
import as from './as.js';
import { c as HiddenToggle, b as HiddenShow, a as HiddenHide } from './chunk-6133b9c9.js';

var OverlayContainer = HiddenContainer;

var OverlayToggle = styled(HiddenToggle).withConfig({
  displayName: "OverlayToggle",
  componentId: "sc-14sj6y8-0"
})(["", ";"], theme("OverlayToggle"));
var OverlayToggle$1 = as("button")(OverlayToggle);

var OverlayShow = styled(HiddenShow).withConfig({
  displayName: "OverlayShow",
  componentId: "sc-3iyuxd-0"
})(["", ";"], theme("OverlayShow"));
var OverlayShow$1 = as("button")(OverlayShow);

var OverlayHide = styled(HiddenHide).withConfig({
  displayName: "OverlayHide",
  componentId: "wcezmi-0"
})(["", ";"], theme("OverlayHide"));
var OverlayHide$1 = as("button")(OverlayHide);

export { OverlayContainer as a, OverlayToggle$1 as b, OverlayShow$1 as c, OverlayHide$1 as d };
